import { useValidationErrorHandle } from "../functions/validationErrorHandle";

type Props = {
  labelClass?: any;
  label?: any;
  name?: any;
  onChange?: any;
  className?: any;
  required?: any;
  value?: any;
  children?: any;
  error?: any;
  type?: any;
  labelMargin?: any;
  dropdowndiv?: any;
  disabled?: any;
  onBlur?: any;
};

export default function DropDown({
  labelClass,
  label,
  name,
  onChange,
  className,
  required,
  children,
  error,
  labelMargin,
  value,
  dropdowndiv,
  disabled,
  onBlur,
}: Props) {
  const validationErrorHandle = useValidationErrorHandle();
  return (
    <div className={` ${dropdowndiv}`}>
      <label className={`block ${labelClass}`} htmlFor={name}>
        {label ? <p className={` ${labelMargin} `}>{label}</p> : " "}
        <select
          disabled={disabled}
          id={name}
          onChange={onChange}
          onBlur={onBlur}
          style={{ color: !value ? "#9ca3af" : "#000000" }}
          className={`block w-full bg-white border py-2 px-4 rounded-md
    focus:border-sky-200 focus:ring-sky-200 focus:outline-none focus:ring 
    focus:ring-opacity-40 [&>option]:text-black ${className}`}
          name={name}
          value={value}
          required={required}
        >
          {children}
        </select>
        {error ? (
          <p className="mt-1 text-red-400 md:text-sm sm:text-[.65rem]">
            {validationErrorHandle(error)}
          </p>
        ) : (
          ""
        )}
      </label>
    </div>
  );
}

DropDown.defaultProps = {
  className: "",
  labelClass: "mb-2 text-sm",
  label: "",
  name: "",
  type: "",
  onChange: "",
  value: "",
  required: false,
  error: "",
  children: "",
  labelMargin: "",
  dropdowndiv: "mt-10",
  onBlur: undefined,
};
